import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import FeaturesSection from './components/FeaturesSection';
import ProgramsSection from './components/ProgramsSection';
import ClassesScheduleSection from './components/ClassesScheduleSection';
import TeamSection from './components/TeamSection';
import MembershipSection from './components/MembershipSection';
import GallerySection from './components/GallerySection';
import TestimonialSection from './components/TestimonialSection';
import CTASection from './components/CTASection';
import EventsSection from './components/EventsSection';
import ContactSection from './components/ContactSection';
import OurGallerySection from './components/OurGallerySection';
import FAQSection from './components/FAQSection';

export default function HomePage() {
  return (
    <main className="bg-black">
      <HeroSection />
      <MembershipSection />
      <AboutSection />
      <FeaturesSection />
      <ProgramsSection />
      <ClassesScheduleSection />
      <TeamSection />
      <GallerySection />
      <TestimonialSection />
      <CTASection />
      <OurGallerySection />
      <EventsSection />
      <FAQSection />
      <ContactSection />
    </main>
  );
}
